export interface DocumentAuditLog {
  id: string;
  event_type: string;
  event_category: string;
  actor_id?: string;
  actor_type: string;
  actor_identifier?: string;
  action: string;
  resource_type?: string;
  resource_id?: string;
  ip_address?: string;
  user_agent?: string;
  request_id?: string;
  details: Record<string, any>;
  status: string;
  error_message?: string;
  timestamp: string;
}

export interface DocumentAuditHistoryResponse {
  audit_logs: DocumentAuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export interface DocumentAuditHistoryRequest {
  document_id?: string;
  document_type?: string;
  operation?: string;
  admin_id?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}

export interface DocumentAuditExportRequest {
  document_id?: string;
  document_type?: string;
  operation?: string;
  admin_id?: string;
  start_date?: string;
  end_date?: string;
  export_format: 'pdf' | 'csv';
}

export interface DocumentAuditExportResponse {
  success: boolean;
  export_url?: string;
  filename?: string;
  total_records: number;
  errors: string[];
}

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  create: 'Created',
  update: 'Updated',
  delete: 'Deleted',
  convert: 'Converted',
  send: 'Sent',
  approve: 'Approved',
  reject: 'Rejected',
  cancel: 'Cancelled',
  confirm: 'Confirmed',
  dispatch: 'Dispatched',
  deliver: 'Delivered',
  invoice: 'Invoiced',
  payment: 'Payment Received'
};

export const AUDIT_STATUS_COLORS: Record<string, 'success' | 'error' | 'warning' | 'info' | 'default'> = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  pending: 'warning',
  failed: 'error',
  completed: 'success'
};